<template>
  <div class="flex" :class="isAI ? 'justify-start' : 'justify-end'">
    <div class="flex gap-2 max-w-[85%]" :class="isAI ? 'flex-row' : 'flex-row-reverse'">
      <!-- 头像 -->
      <div class="w-8 h-8 rounded-full flex-shrink-0 flex items-center justify-center" 
        :class="isAI ? 'bg-blue-500' : 'bg-gray-200 dark:bg-gray-700'">
        <span class="text-base">{{ isAI ? '🤖' : '👤' }}</span>
      </div>
      
      <!-- 消息内容 -->
      <div class="space-y-1">
        <div class="text-xs text-gray-500 dark:text-gray-400 px-2">
          {{ isAI ? 'AI助手' : '你' }}
        </div>
        <div class="message-bubble" 
          :class="[isAI ? 'bg-white dark:bg-gray-800' : 'bg-blue-500 text-white']"
        >
          <div v-if="isMarkdown" 
            class="prose dark:prose-invert max-w-none prose-sm" 
            v-html="renderedContent"
          ></div>
          <div v-else class="whitespace-pre-wrap text-sm">{{ content }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { marked } from 'marked'
import DOMPurify from 'dompurify'

// 配置 marked 选项
marked.setOptions({
  breaks: true, // 支持换行
  gfm: true, // 支持 GitHub 风格的 Markdown
})

export default {
  name: 'ChatBubble',
  props: {
    content: {
      type: String,
      required: true
    },
    isAI: {
      type: Boolean,
      default: false
    },
    isMarkdown: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    renderedContent() {
      if (!this.isMarkdown) return this.content
      const rawHtml = marked(this.content)
      return DOMPurify.sanitize(rawHtml)
    }
  }
}
</script>

<style scoped>
.message-bubble {
  @apply p-3 rounded-xl shadow-sm;
  max-width: 100%;
}

/* 添加代码块样式 */
:deep(.prose pre) {
  @apply bg-gray-800 text-white p-3 rounded-lg my-2 text-sm;
  overflow-x: auto;
}

:deep(.prose code) {
  @apply bg-gray-100 dark:bg-gray-700 px-1 rounded text-sm;
}

:deep(.prose p) {
  @apply my-1.5 text-sm;
}

:deep(.prose ul),
:deep(.prose ol) {
  @apply my-1.5 pl-4 text-sm;
}

:deep(.prose li) {
  @apply my-0.5;
}

:deep(.prose blockquote) {
  @apply border-l-4 border-gray-300 dark:border-gray-600 pl-3 my-1.5;
}
</style> 